import useGlobalState from '@components/Hooks/useGlobalState';
import Error from '@Shared/Error';
import React from 'react';

const GetStartedError: React.FC = () => {

  const [store,] = useGlobalState();

  return store.requested?.message ? (
    <Error>
      <p>{store.requested?.message}</p>
    </Error>
  ) : null;
}

export default GetStartedError;